import { Component } from '@angular/core';
import { APPCONFIG } from '../../config';
import { Router }  from '@angular/router';
import { ErrorHandler } from '../../shared/services/error-handler.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { HttpService } from '../../shared/services/http.service';
import { CommonService } from '../../shared/services/common.service';
import { LayoutService } from '../../layout/layout.service';

@Component({
    selector: 'my-app-header',
    styles: [require('./header.component.css')],
    template: require('./header.component.html')
})

export class AppHeaderComponent {
    AppConfig: any;
    public userDetails: any;
    showPasswordBanner = false;
    private readonly bannerDismissKey = 'ppb_dismissed_v1';
    private readonly lastDateToShowISO = '2026-02-08';

    constructor(private router: Router,public httpService : HttpService,public errorHandler : ErrorHandler,
                public layoutService : LayoutService, public sessionHandler : SessionHandler, public commonService:CommonService){

        this.userDetails={image:''};

        try {
            if(this.sessionHandler.getItem("userDetails") != null) {
                this.userDetails = JSON.parse(this.sessionHandler.getItem("userDetails"));
                if(!this.userDetails) throw "Invalid user details.";
            }else {
                this.router.navigate(['/login']);
            }
        }catch(err){
            this.router.navigate(['/login']);
        }
    }

    logout() {
        //this.commonService.setLoginRedirectUrl(window.location.hash);
        this.sessionHandler.removeItem('loginData');
        this.sessionHandler.removeItem('timestamp');
        this.sessionHandler.removeItem('userDetails');
        this.router.navigate(['/login']);
    }

    public saveResponse(res){
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            alert('Not able to Logout Please Try Again');
        } else {
            this.httpService.onEnd();
            //this.commonService.setLoginRedirectUrl('');
            this.sessionHandler.clearAllItems();
            this.router.navigate(['/login']);
        }
    }

    toggleCollapsedNav() {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    }

    private evaluatePasswordBannerVisibility(): void {
    const dismissed = localStorage.getItem(this.bannerDismissKey) === '1';
 
    // Calculate if today <= 2026-02-08 (your local timezone)
    const today = new Date();
    const endDate = new Date(this.lastDateToShowISO + 'T23:59:59');
 
    this.showPasswordBanner = !dismissed && today.getTime() <= endDate.getTime();
  }
 
  dismissPasswordBanner(): void {
    localStorage.setItem(this.bannerDismissKey, '1');
    this.showPasswordBanner = false;
  }
 
  onChangePasswordClick(event: Event): void {
    this.redirectForgotPassword();
  }
 
 
  redirectForgotPassword() {
        window.open("/#/forgot-password", "_blank");
      }

    ngOnInit() {
        this.AppConfig = APPCONFIG;
        this.evaluatePasswordBannerVisibility();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/header/header.component.ts